<template>
	<row-object-page name="file_edit" :oref="oref" v-model="file"></row-object-page>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";
import RowObjectPage from "@/pages/row-object/RowObjectPage.vue";
import {objectRef, RowObjectInit, RowObjectRef, RowObjectType, SrcType} from "@t/meta/SourceType.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import type {AttFile} from "@t/file/AttFile.ts";
import {connectEventBus, injectEnv} from "@fd/Environment.ts";
import {CREATE, EDIT, REPLACE_INIT_WITH_EDIT} from "@/pages/row-object/RowObjectEvents.ts";
import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";

const ns = useNavigationStore();
const env = injectEnv();
const bus = connectEventBus("FilePage");

const file = ref<AttFile>(null);
const rowObject = ref<InstanceType<typeof RowObjectPage> | null>(null);
const route = useVirtualRoute();
const oref = objectRef(route, SrcType.ATTFILE);

ns.listenForStackerUpdates(bus, oref, () => env.msg('title.createFile'),
	"/editFile.do", () => file.value.name, () => file.value.id);
</script>

<style>
</style>